export class DropdownModel {
    constructor(public id: number, public text: string) { }
  }
